<template>
	<div>

		<!-- Botón par aexportar -->
	  <v-tooltip bottom>
	    <template v-slot:activator="{ on, attrs }">
	      <v-btn
	        v-bind="attrs"
	        v-on="on"
	        class="mr-2" 
	        small dark color="green"
	        @click="$emit('exportarRol')"
	        tile
	      >
	        <v-icon>mdi-microsoft-excel</v-icon>
	      </v-btn>
	    </template>
	    <span>Descargar rol completo</span>
	  </v-tooltip>

    <!-- <v-tooltip bottom>
	    <template v-slot:activator="{ on, attrs }">
	      <v-btn
	        v-bind="attrs"
	        v-on="on"
	        class="mr-2"
	        small dark color="blue"
	        @click="$emit('configuracionTeachers')"
	        tile
	      >
	        <v-icon>mdi-account</v-icon>
	      </v-btn>
	    </template>
	    <span>Configuración de teachers</span>
	  </v-tooltip> -->

		<!-- Botón par aexportar -->
	  <!-- <v-tooltip bottom>
	    <template v-slot:activator="{ on, attrs }">
	      <v-btn
	        v-bind="attrs"
	        v-on="on"
	        class="mr-2"
	        small dark color="green"
	        @click="$emit('exportarDominical')"
	        tile
	      >
	        <v-icon>mdi-currency-usd</v-icon>
	      </v-btn>
	    </template>
	    <span>Descargar Catorcena</span>
	  </v-tooltip> -->

	  <!-- Botón par aexportar -->
	  <!-- <v-tooltip bottom>
	    <template v-slot:activator="{ on, attrs }">
	      <v-btn
	        dark
	        v-bind="attrs"
	        v-on="on"
	        class="mr-2" 
	        small 
          color="orange"
	        @click="$emit('exportarSabatino')"
	        tile
	      >
	        <v-icon>mdi-currency-usd</v-icon>
	      </v-btn>
	    </template>
	    <span>Nómina Sabatino</span>
	  </v-tooltip> -->

    <!-- Botón para las clases dobles -->
    <!-- <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          class="mr-2" 
          small color="pink"
          @click="$emit('dialogBonos')"
          tile
        >
          <v-icon small color="white">mdi-account-multiple-plus</v-icon>
        </v-btn>
      </template>
      <span>Bono Teachers</span>
    </v-tooltip> -->

    <!-- Panel de disponibilidad para cubrir clases -->
    <!-- <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          class="mr-2"
          small
          color="teal"
          @click="$emit('dialogDisponibilidad')"
          tile
        >
          <v-icon small>mdi-calendar-clock</v-icon>
        </v-btn>
      </template>
      <span>Panel de disponibilidad para cubrir clases</span>
    </v-tooltip> -->

    <!-- Botón para las clases dobles -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          class="mr-2" 
          small color="yellow"
          @click="$emit('dialogHorasDobles')"
          tile
        >
          <v-icon small color="black">mdi-account-multiple-plus</v-icon>
        </v-btn>
      </template>
      <span>Horas Dobles</span>
    </v-tooltip>

    <!-- KPI Contabilización de clases / cambios -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          class="mr-2"
          small
          color="deep-purple"
          @click="$emit('dialogKpiRoles')"
          tile
        >
          <v-icon small>mdi-chart-box</v-icon>
        </v-btn>
      </template>
      <span>KPI Roles — clases y cambios</span>
    </v-tooltip>

    <!-- Carga laboral por teacher / plantel -->
    <v-tooltip bottom v-if="mostrarCargaLaboral">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          class="mr-2"
          small
          color="teal darken-1"
          @click="$emit('dialogCargaLaboral')"
          tile
        >
          <v-icon small>mdi-briefcase-clock</v-icon>
        </v-btn>
      </template>
      <span>Carga laboral</span>
    </v-tooltip>

	  <!-- Boton para cagar la información de los catalagos del ERP en el LMS -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          class="mr-2" 
          small 
          color="red"
	        @click="$emit('dialogSinTeacher')"
          tile
        >
          <v-icon small>mdi-account-cancel</v-icon>
        </v-btn>
      </template>
      <span>Grupos sin teacher</span>
    </v-tooltip>

    <!-- Boton para cagar la información de los catalagos del ERP en el LMS -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          class="mr-2" 
          small 
          color="black"
	        @click="$emit('dialogRolados')"
          tile
        >
        	<v-icon small>mdi-account-convert</v-icon>
        </v-btn>
      </template>
      <span>Teacher rolados</span>
    </v-tooltip>

    <!-- Botón para ver los teachers no rolados -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          class="mr-2" 
          small  color="purple"
	        @click="$emit('dialogNoRolados')"
          tile
        >
        	<v-icon small>mdi-account-alert</v-icon>
        </v-btn>
      </template>
      <span>Teachers No rolados</span>
    </v-tooltip>


    <!-- Botón para ver los teachers no rolados -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          class="mr-2" 
          small  color="brown"
          @click="$emit('dialogConfirmados')"
          tile
        >
          <v-icon small>mdi-account-check</v-icon>
        </v-btn>
      </template>
      <span>Teachers No Confirmados</span>
    </v-tooltip>



    <!-- Boton para cagar la información de los catalagos del ERP en el LMS -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          class="mr-2" 
          small 
          color="cyan darken-4"
	        @click="$emit('cargarCatalogos')"
          tile
        >
          <v-icon small>mdi-folder-upload</v-icon>
        </v-btn>
      </template>
      <span>Cargar catálogos al LMS</span>
    </v-tooltip>

    <!-- Copiar maestros entre ciclos (maestrosgrupo vía grupo consecutivo) -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          class="mr-2"
          small
          color="indigo darken-1"
          @click="$emit('dialogCopiarRol')"
          tile
        >
          <v-icon small>mdi-content-copy</v-icon>
        </v-btn>
      </template>
      <span>Copiar maestros entre ciclos</span>
    </v-tooltip>

    <!-- Boton para cagar la información del bloque al sistema -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          class="mr-2" 
          small  color="blue"
	        @click="$emit('cargarBloque')"
          tile
        >
          <v-icon small>mdi-progress-upload</v-icon>
        </v-btn>
      </template>
      <span>Cargar Rol al Sistema</span>
    </v-tooltip>

    <!-- Botón para liberar los grupos para que los valide el teacher -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          class="mr-2" 
          small color="pink"
          @click="$emit('enviarRol')"
          tile
        >
          <v-icon small>mdi-lock-open</v-icon>
        </v-btn>
      </template>
      <span>Enviar Rol</span>
    </v-tooltip>

    <!-- Boton para cagar la información del bloque al sistema -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
          class="mr-2" 
          small 
          color="lime accent-4"
          @click="$emit('verificacionRol')"
          tile
        >
          <v-icon small color="black">mdi-close-network</v-icon>
        </v-btn>
      </template>
      <span>Verificación de Rol</span>
    </v-tooltip>

    <!-- Botón para consultar la iformación al sistema -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="mr-2"
          small
          dark
          color="orange"
          tile
          @click="$emit('consultar')"
        >
          <v-icon small>mdi-refresh</v-icon>
        </v-btn>
      </template>
      <span>Actualizar</span>
    </v-tooltip>

    <!-- Esther / Paola: cambios de personal -->
    <v-tooltip bottom v-if="mostrarCambiosPersonal">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="mr-2"
          small
          dark
          color="deep-purple"
          tile
          @click="$emit('dialogCambiosPersonal')"
        >
          <v-icon small>mdi-account-switch</v-icon>
        </v-btn>
      </template>
      <span>Cambios de personal por grupo</span>
    </v-tooltip>

	</div>
</template>
<script>
export default {
  props: {
    mostrarCambiosPersonal: { type: Boolean, default: false },
    mostrarCargaLaboral: { type: Boolean, default: false },
  },
}
</script>